export function calculate_power_buy(per_buy, per_sell) {

    if (per_buy >= per_sell) {
        return per_buy / per_sell
    } else {
        return (per_sell / per_buy) * -1
    }
}


export const showAlarm = (row, stock) => {
    if (row.alarm[stock] !== undefined){
        if (row.alarm[stock] === 1 ){
            return 'نوسانی'
        }else if (row.alarm[stock] === 2){
            return 'صعودی'
        }else if (row.alarm[stock] === 3){
            return 'ریزشی'
        }else if (row.alarm[stock] === 4) {
            return 'x'
        }else {
            return 'x'
        }
    }
}

export const showAlarmClass = (row, stock) => {
    if (row.alarm[stock] !== undefined){
        if (row.alarm[stock] === 1 ){
            return ''
        }else if (row.alarm[stock] === 2){
            return 'text-primary'
        }else if (row.alarm[stock] === 3){
            return 'text-danger'
        }else if (row.alarm[stock] === 4) {
            return 'x'
        }else {
            return 'x'
        }
    }
}

export const showActivity = (row, stock) => {
    if (row.alarm[stock] !== undefined){
        if (row.alarm[stock] === 1 ){
            return 'نوسانگیری'
        }else if (row.alarm[stock] === 2){
            return 'س.گ.م.م'
        }else if (row.alarm[stock] === 3){
            return 'ن.و.د.ث'
        }else if (row.alarm[stock] === 4) {
            return 'x'
        }else {
            return 'x'
        }
    }
}